import { useEffect, useState } from 'react';
import { api, devToken } from './api';
import { loadSecure } from './crypto';
import { providerOf } from './models';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Downscale a photo/screenshot to ≤1600px JPEG so it uploads fast and fits vision limits. */
export async function resizeImage(file, max = 1600) {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((ok, ko) => { const i = new Image(); i.onload = () => ok(i); i.onerror = () => ko(new Error('Immagine non leggibile')); i.src = url; });
    const k = Math.min(1, max / Math.max(img.width, img.height));
    const c = document.createElement('canvas');
    c.width = Math.round(img.width * k); c.height = Math.round(img.height * k);
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    return c.toDataURL('image/jpeg', 0.85);
  } finally { URL.revokeObjectURL(url); }
}

export const uploadAttachment = (dataUrl) => api('/architect/attachments', { method: 'POST', body: { data_url: dataUrl }, auth: true, timeout: 60000 }).then((r) => r.id);

const cache = new Map();
export function useAttachmentUrl(id) {
  const [url, setUrl] = useState(cache.get(id) || null);
  useEffect(() => {
    if (!id || cache.has(id)) return undefined;
    let alive = true;
    fetch(`${API}/architect/attachments/${id}`, { headers: { Authorization: `Bearer ${devToken.get()}` } })
      .then((r) => (r.ok ? r.blob() : null)).then((b) => { if (b && alive) { const u = URL.createObjectURL(b); cache.set(id, u); setUrl(u); } }).catch(() => {});
    return () => { alive = false; };
  }, [id]);
  return url;
}

/** OpenAI key for voice/covers: dedicated key, else the main key if it is OpenAI. */
export async function openaiKey() {
  const s = await loadSecure('settings');
  return s?.coverKey || ((s?.byokProvider || providerOf(s?.byokModel)) === 'openai' ? s?.apiKey : null) || null;
}

export async function transcribe(blob, key) {
  const fd = new FormData();
  fd.append('file', blob, 'voce.webm');
  fd.append('openai_key', key);
  const r = await fetch(`${API}/architect/transcribe`, { method: 'POST', headers: { Authorization: `Bearer ${devToken.get()}` }, body: fd });
  const j = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(j.detail || 'Trascrizione non riuscita');
  return j;
}
